import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { videoInitialValues } from 'components/organisms/forms/video/VideoForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiVinylRecord, PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { STATUS } from 'services/types';
import { usePostVideo } from 'services/video';
import { usePostVideoChunkedFile } from 'services/video/file';
import { IVideoMutationForm } from 'services/video/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowToast } from 'utils/service/errorHandler';

const CreateVideo = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const createVideo = usePostVideo();
  const addVideoChunkedFile = usePostVideoChunkedFile();
  const mutateOptions = useMutateOptions<IVideoMutationForm>();

  const onGoToDetail = (id: string) => navigate(`/video/${id}/file`);

  const onCreateVideoFile = async (file: File, videoId: string) => {
    await addVideoChunkedFile.mutateAsync(
      { file, videoId },
      {
        onError: error => {
          onErrorShowToast(error, 'toast-message.add-file');
          onGoToDetail(videoId);
        },
        onSuccess: () => onGoToDetail(videoId),
      }
    );
  };

  const onCreateVideo = async (
    values: IVideoMutationForm,
    helpers: FormikHelpers<IVideoMutationForm>
  ) => {
    const video = {
      ...middleware.video.formToQuery(values),
      waitingForFile: !!values.file && values.status !== STATUS.draft,
    };

    await createVideo.mutateAsync(video, {
      ...mutateOptions(helpers),
      onSuccess: video =>
        !!values.file
          ? onCreateVideoFile(values.file, video.id)
          : onGoToDetail(video.id),
    });
  };

  return (
    <Form.Video
      i18nextPrefix='video'
      initialValues={videoInitialValues}
      onSubmit={onCreateVideo}
      tittle={t('create-video.topbar.title')}
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate('/video')}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
          <Button.Icon icon={<PiVinylRecord />} />
        </Button>
      }
    />
  );
};

export default CreateVideo;
